import React from 'react';
import PropTypes from 'prop-types';

import ContextMenu from './contextMenu/context-menu';
import {
    MenuOrga,
    SideMenuEvent,
    SideMenuPartner,
    SideMenuTicketOffices,
    SideMenuCharts,
    SideMenuWebservices,
    SideMenuModeration,
    SideMenuPersonalSpace,
    SideMenuOnlineTicketing,
    SideMenuProduct
} from '../routing/sidebarMenu';

export default function SideBarMenu({ organization, event, partner, chart, ticket_office, syncTicketOffice, webservice, moderationFlowId, personal_space, product, ticket_shop }) {
    let menus = null;

    // We have no organization, no need to show menu
    if (!organization) {
        return null;
    }

    // We are in organization mode
    if (!event && !partner && !ticket_office && !chart && !webservice && !personal_space && !ticket_shop && !product) {
        menus = <MenuOrga organization={organization} />;
    } else if (!ticket_office && !partner) {
        menus = <SideMenuEvent organizationId={organization.id} event={event} />;
    }
    //We are in partner mode
    if (partner) {
        menus = <SideMenuPartner organizationId={organization.id} partnerId={partner.pk} />;
    }
    // We are in ticket office mode
    if (ticket_office) {
        menus = <SideMenuTicketOffices organizationId={organization.id} ticket_office={ticket_office} />;
    }

    if (chart) {
        menus = <SideMenuCharts organizationId={organization.id} chart={chart} />;
    }

    if (webservice) {
        menus = <SideMenuWebservices organizationId={organization.id} webservice={webservice} />;
    }

    if (moderationFlowId) {
        menus = <SideMenuModeration organizationId={organization.id} />;
    }

    if (personal_space) {
        menus = <SideMenuPersonalSpace organizationId={organization.id} personal_space={personal_space} />;
    }

    if (product) {
        menus = <SideMenuProduct organizationId={organization.id} product={product} />;
    }

    if (ticket_shop) {
        menus = <SideMenuOnlineTicketing organizationId={organization.id} ticket_shop={ticket_shop} />;
    }

    return (
        <React.Fragment>
            <ContextMenu
                organization={organization}
                chart={chart}
                webservice={webservice}
                partner={partner}
                event={event}
                ticket_office={ticket_office}
                syncTicketOffice={syncTicketOffice}
                moderationFlowId={moderationFlowId}
                personal_space={personal_space}
                product={product}
                ticket_shop={ticket_shop}
            />
            {menus}
        </React.Fragment>
    );
}

SideBarMenu.propTypes = {
    organization: PropTypes.object,
    event: PropTypes.object,
    partner: PropTypes.object,
    ticket_office: PropTypes.object,
    product: PropTypes.object
};
